import React from 'react';

const Home = () => {
  return (
    <div className="page">
      <div className="page-header">
        <h1>Bienvenue sur l'API WhakUp</h1>
        <p>
          Documentation complète pour intégrer WhakUp dans votre application.
          Découvrez comment envoyer des messages WhatsApp, gérer vos contacts et créer des campagnes automatisées.
        </p>
      </div>

      <div className="section">
        <h2>🎯 Fonctionnalités Principales</h2>
        <ul>
          <li><strong>Authentification API Key</strong> - Système d'authentification sécurisé</li>
          <li><strong>Gestion des Workspaces</strong> - Accès à vos workspaces via API</li>
          <li><strong>Rate Limiting</strong> - Système de limitation pour protéger l'API</li>
        </ul>
        <div className="alert alert-info">
          <strong>📌 Note :</strong> D'autres fonctionnalités (contacts, campagnes, webhooks) seront 
          disponibles prochainement dans l'API publique.
        </div>
      </div>

      <div className="section">
        <h2>🚀 Démarrage Rapide</h2>
        <ol>
          <li>Créez un compte sur WhakUp</li>
          <li>Obtenez votre API Key depuis votre tableau de bord</li>
          <li>Utilisez l'API Key pour obtenir un JWT</li>
          <li>Commencez à intégrer l'API dans votre application</li>
        </ol>

        <div className="code-block">
{`// Exemple d'authentification
POST /api/public/auth
Headers:
  X-API-Key: whk_live_votre_cle_api

Réponse:
{
  "token": "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9...",
  "user": { ... },
  "workspaces": [ ... ]
}`}
        </div>
      </div>

      <div className="section">
        <h2>📊 Base URL</h2>
        <div className="code-block">
          Production: https://api.whakup.com
          Local: http://127.0.0.1:8000
        </div>
      </div>

      <div className="section">
        <h2>📚 Navigation</h2>
        <p>Utilisez le menu à gauche pour naviguer dans la documentation :</p>
        <ul>
          <li><strong>Authentification</strong> - Guide complet de l'authentification avec API Key</li>
          <li><strong>Endpoints</strong> - Documentation détaillée des endpoints disponibles</li>
          <li><strong>Exemples</strong> - Exemples de code en JavaScript, PHP, Python</li>
          <li><strong>Rate Limiting</strong> - Comprendre et gérer les limites de l'API</li>
        </ul>
      </div>
    </div>
  );
};

export default Home;
